import React, { useEffect, useState } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Input } from "reactstrap";

/**
 * used to edit name and description of generic components
 * @param {function} toggleShowModal to show/hide the modal
 * @param {object} data current name and description
 * @param {function} confirmChanges returns the updated information
 * @param {boolean} showModal show the modal - true or false
 * @returns a modal to allow user to input new values for component's name and description.
 */
function EditNameAndDescription({
  toggleShowModal,
  data,
  confirmChanges,
  showModal
}) {
  const [name, setName] = useState(data.name || "No name provided");
  const [description, setDescription] = useState(data.description || "");
  const [disableUpdate, setDisableUpdate] = useState(true);
  const [nameError, setNameError] = useState(false);

  const onClickCancel = () => {
    setName(data.name);
    setDescription(data.description);
    toggleShowModal();
  };

  const onClickUpdate = () => {
    confirmChanges(name, description);
    toggleShowModal();
  };

  useEffect(() => {
    if (!name.length) {
      setDisableUpdate(true);
    } else if (name.length > 99) {
      setDisableUpdate(true);
    } else if (name === data.name && description === data.description) {
      setDisableUpdate(true);
    } else {
      setDisableUpdate(false);
    }

    if (!name.length) {
      setNameError(true);
    } else {
      setNameError(false);
    }
    //  eslint-disable-next-line react-hooks/exhaustive-deps
  }, [name, description]);

  return (
    <Modal centered backdrop isOpen={showModal}>
      <ModalHeader>Edit Name - Description</ModalHeader>
      <ModalBody>
        <p>
          <span className="header-modal-text">
            Name
            {nameError && <span className="input-required">*Required</span>}
          </span>
          <Input
            type="text"
            onChange={(e) => setName(e.target.value)}
            value={name}
          />
        </p>
        <p>
          <span className="header-modal-text">
            Description
          </span>
          <textarea
            rows="3"
            className="form-control"
            onChange={(e) => setDescription(e.target.value)}
            value={description}
          ></textarea>
        </p>
      </ModalBody>
      <ModalFooter>
        <Button className="promote" onClick={onClickCancel}>
          Cancel
        </Button>
        <Button onClick={onClickUpdate} disabled={disableUpdate}>
          Update
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default EditNameAndDescription;


/* 
 * used to edit the description only
 * pass the name and description of the file in an object as 'data'
*/
export function EditDescription({
  toggleShowModal,
  data,
  confirmChanges,
  showModal
}) {

  const [name] = useState(data.name || "No name provided");
  const [description, setDescription] = useState(data.description || "");
  const [disableUpdate, setDisableUpdate] = useState(true);

  const onClickCancel = () => {
    setDescription(data.description);
    toggleShowModal();
  };

  const onClickUpdate = () => {
    confirmChanges(description);
    toggleShowModal();
  };

  useEffect(() => {
    if (description === data.description) {
      setDisableUpdate(true);
    } else {
      setDisableUpdate(false);
    }

    //  eslint-disable-next-line react-hooks/exhaustive-deps
  }, [description]);

  return (
    <Modal centered backdrop isOpen={showModal}>
      <ModalHeader>Edit Description</ModalHeader>
      <ModalBody>
        <p>
          <span className="header-modal-text">
            Name: 
          </span>
          <span>{name}</span>
        </p>
        <p>
          <span className="header-modal-text">
            Description
          </span>
          <textarea
            rows="3"
            className="form-control"
            onChange={(e) => setDescription(e.target.value)}
            value={description}
          ></textarea>
        </p>
      </ModalBody>
      <ModalFooter>
        <Button className="promote" onClick={onClickCancel}>
          Cancel
        </Button>
        <Button onClick={onClickUpdate} disabled={disableUpdate}>
          Update
        </Button>
      </ModalFooter>
    </Modal>
  );
}